import { useCallback } from 'react';
import { FrontSide } from 'three';
import { useThree } from '@react-three/fiber';
import { Sphere } from '@react-three/drei';
import useMirror from '../common/useMirror';
import { useAsset } from '@artica/assets';
import { parallax } from '@immutabl3/alchemy/three';
import orbAnim from './Orb.animation.json';
import EclipseContent from './EclipseContent';

const ParallaxSphere = parallax(Sphere);

const OrbMaterial = function() {
  return (
    <parallax.meshPhysicalMaterial
      beaker="chapter1"
      animation={ orbAnim }

      roughness={ 0.1 }
      ior={ 1.1 }
      reflectivity={ 0.8 }
      specularIntensity={ 1 }
      transparent={ true }
      thickness={ 1.1 }
      transmission={ 0 }
      emissiveIntensity={ 1 }
      emissive={ [10, 9, 8] }
      map={ useAsset('orb_albedo') }
      side={ FrontSide }
    />
  );
};

export default function Orb() {
  const mirror = useMirror(1, 5000, [0, 1, 0]);
  const {
    scene,
    camera,
    gl: renderer,
  } = useThree(({ gl, scene, camera }) => ({ gl, scene, camera }));

  const onPercChange = useCallback((_, ref) => {
    const orb = ref.current;
    if (!orb) return;

    orb.lookAt(camera.position);

    mirror.position.set(orb.position.x, orb.position.y, orb.position.z);
    mirror.update(renderer, scene);
  }, [camera, renderer, scene]);

  return (
    <ParallaxSphere
      args={ [0.2] }
      name="Sphere"
      beaker="chapter1"
      onPercChange={ onPercChange }
    >
      <OrbMaterial />
      <pointLight
        color={ 0xff9966 }
        intensity={ 15 }
        distance={ 5 }
        decay={ 2 }
      />
      <EclipseContent />
    </ParallaxSphere>
  );
};